export default __webpack_public_path__ + "static/media/s3_female.0bbe082d.wav";